import { useState } from "react";
import { Square, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/App";
import { Button } from "@/components/ui/button";

export default function StopScraperButton({ endpoint, running, onStopped, testId }) {
  const [stopping, setStopping] = useState(false);

  const stop = async () => {
    setStopping(true);
    try {
      const { data } = await api.post(endpoint);
      data.stopped ? toast.success("Scraper gestoppt") : toast.info(data.message || "Scraper läuft nicht");
      await onStopped?.();
    } catch (error) {
      toast.error(error?.response?.data?.detail || "Konnte Scraper nicht stoppen");
    } finally {
      setStopping(false);
    }
  };

  return (
    <Button
      data-testid={testId}
      type="button"
      variant="outline"
      onClick={stop}
      disabled={!running || stopping}
      className="border-[#D32222]/70 bg-transparent text-[#E13636] hover:bg-[#D32222]/10 hover:text-[#F05252] disabled:border-neutral-700 disabled:text-neutral-600"
    >
      {stopping ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Square className="w-4 h-4 mr-2 fill-current" />}
      Stoppen
    </Button>
  );
}
